import $ from 'jquery';
import fetch from 'utils/fetch';
import { error as toastError, success as toastSuccess } from 'plugins/toastr';
import { displayLoader, hideLoader } from 'plugins/loader';

export default function contractFileTableHandler(ctx) {
  $('.contract.upload.button').on('click', evt => {
    $('#uploadContractInput').trigger('click');
  });

  const url = $('#uploadContractInput').data('url')
    ? $('#uploadContractInput').data('url')
    : '';

  $('#uploadContractInput').on('change', evt => {
    const file = evt.target.files[0];

    if (file) {
      let fd = new FormData();
      fd.append('contract', file);
      displayLoader();
      fetch(url, {
        method: 'POST',
        body: fd,
      })
        .then(res => {
          toastSuccess('Le fichier a été téléchargé avec succès');
          hideLoader();
          return res.text();
        })
        .then(refreshContractTable, error => {
          hideLoader();
          toastError('Une erreur est survenue pendant la sauvegarde.');
        });
    }
  });

  enableDeleteButtons();
  handleOrganizeLink();
  handleFileVisibility();
}

function handleOrganizeLink() {
  const $button = $('#organize-btn');

  $button.on('click', evt => {
    evt.preventDefault();

    const url = $button.attr('href');
    const ref = $('#reference').val();
    const start = $('#start_date').val();
    const end = $('#end_date').val();
    const autoRenewal = $('#automatic_renewal').checkbox('is checked')
      ? 'on'
      : 'off';

    window.location.href =
      url +
      '?reference=' +
      ref +
      '&start_date=' +
      start +
      '&end_date=' +
      end +
      '&automatic_renewal=' +
      autoRenewal;
  });
}

function handleFileVisibility() {
  const $linkedSiteDropdowns = $('input[name="linkedSites"]').parents(
    '.multiple.search.selection.dropdown'
  );

  $('.contractRow .ui.checkbox.checked').checkbox('set checked');
  $linkedSiteDropdowns.dropdown();

  $linkedSiteDropdowns.each((_, elem) => {
    const $techInput = $(elem)
      .parents('.contractRow')
      .find('input[name="isTechAccessAllowed"]')
      .parent('.ui .checkbox');

    if (!$techInput.hasClass('checked')) {
      $(elem).addClass('disabled');
    }
  });
  $('.contractRow input[name="isCustomerAccessAllowed"]').on('change', evt => {
    $(evt.target)
      .closest('form')
      .submit();
  });
  $('.contractRow input[name="isTechAccessAllowed"]').on('change', evt => {
    $(evt.target)
      .closest('form')
      .submit();
  });

  $('.contractRow input[name="linkedSites"]').on('change', event => {
    $(event.target)
      .closest('form')
      .submit();
  });
}

export function refreshContractTable(content) {
  let contractList = document.getElementById('contractList');
  contractList.innerHTML = content;

  enableDeleteButtons();
  handleFileVisibility();
}

export function enableDeleteButtons() {
  $('.button.deleteContract').on('click', evt => {
    evt.preventDefault();

    const $button = $(evt.currentTarget);
    const url = $button.attr('data-url');

    if (url) {
      $('.modal.delete')
        .modal({
          onApprove: element => {
            displayLoader();
            fetch(url, { method: 'DELETE' })
              .then(res => {
                $('.modal.delete').modal('hide');
                hideLoader();
                return res.text();
              })
              .then(
                res => {
                  toastSuccess("L'élément a été supprimé");
                  refreshContractTable(res);
                },
                error => {
                  hideLoader();
                  toastError('Une erreur est survenue pendant la suppression.');
                }
              );
            return false;
          },
        })
        .modal('show');
    }
  });
}



// WEBPACK FOOTER //
// ./src/modules/saas/pco/cases/contract/index.js